/* eslint-disable react/jsx-no-target-blank */
import { isEmpty } from "lodash";
import React from "react";
import Modal from "../Modal";
import DefaultPeople from "../../assets/images/partners/default-people.png";

const PartnerDetailModal = (props) => {
  const { isOpen, partner, onClose } = props;
  return (
    <Modal
      isOpen={isOpen && !isEmpty(partner)}
      close={() => onClose(false)}
      toggle={() => onClose(false)}
      scrollBehavior="inside"
      isCentered
    >
      {!isEmpty(partner) && (
        <div className="partner-detail-wrap">
          <div className="partner-detail-box">
            <div
              className="partner-photo"
              style={{
                backgroundImage: `url(${partner?.imageFile?.fileUrl || DefaultPeople
                  })`,
              }}
            />
            <div className="partner-info">
              <div borderTop="1px solid #000000">
                <div className="partner-name">{partner.name}</div>
              </div>
              <table className="partner-info-table">
                <tbody>
                  {partner.ceoName && (
                    <tr>
                      <th>대표자</th>
                      <td>{partner.ceoName}</td>
                    </tr>
                  )}
                  {partner.from && (
                    <tr>
                      <th>설립일</th>
                      <td>{partner.from}</td>
                    </tr>
                  )}
                  {partner.memberInfo && (
                    <tr>
                      <th>구성인원</th>
                      <td>{partner.memberInfo}</td>
                    </tr>
                  )}
                  {partner.branchStatus && (
                    <tr>
                      <th>지점현황 </th>
                      <td>{partner.branchStatus}</td>
                    </tr>
                  )}
                  {partner.mainTask && (
                    <tr>
                      <th>주요업무</th>
                      <td>
                        {partner.mainTask.split("\n").map((task, idx) => (
                          <div
                            key={idx}
                            dangerouslySetInnerHTML={{
                              __html: task || "",
                            }}
                          />
                        ))}
                      </td>
                    </tr>
                  )}
                  {partner.address && (
                    <tr>
                      <th>주소</th>
                      <td>
                        {partner.address} {partner.addressDetail}
                      </td>
                    </tr>
                  )}
                  {partner.homepage && (
                    <tr>
                      <th>홈페이지</th>
                      <td>
                        <a href={partner.homepage} target="_blank">
                          {partner.homepage}
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {partner.memo && <div className="partner-memo">{partner.memo}</div>}
        </div>
      )}
    </Modal>
  );
};

export default PartnerDetailModal;
